export default "__VITE_ASSET__30940563__"